import request from '../../untils/request'

//竞媒对比 播报
export const Uramvideo = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/mediaRatio/getMediaRatioList',
    params
  })
}
// 热词新闻汇聚
export const hotWord = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/hotWordNews/getHotWordNews',
    params
  })
}
// 热词新闻汇聚返回参数
export const hotBor = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/hotWordNews/getDataSourceList',
    params
  })
}
// 热词新闻汇聚返回参数
export const hotHor = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/hotWordNews/getAllClassification',
    params
  })
}

//红山网数据分析(王岩)
export const RedList = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/hongShan/getHongShanApp',
    params
  })
}

//红山网数据分析(王岩ecahrts)
export const Redecharts = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/hongShan/getHongShanAppGroup',
    params
  })
}
//红山网数据分析(弹框)
export const RedeID = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/hongShan/getArticleReprint',
    params
  })
}




//红山网数据分析(赵志飞)
export const RedNetWork = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/hongShan/getNews',
    params
  })
}
//全市各单位最新发布(新版）
export const Qubot = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/XjSource/getNews',
    params
  })
}


//素材文档饼图
export const getFodderList = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/Uram/getFodderList',
    params
  })
}
//素材文档柱图
export const getAmountList = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/Uram/getAmountList',
    params
  })
}
//媒体传播力
export const getmedia = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/Uram/getmedia',
    params
  })
}
//微博微信发布 --获取BCI相关数据
export const Wban = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/ranking/getWbRankingList',
    params
  })
}   
//微博微信发布(发布排名)
export const releaseRanking = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/ranking/releaseRanking',
    params
  })
}
//抖音排行榜(发布排名)
export const getDyRankingInfo = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/ranking/getDyRankingInfo',
    params
  })
}
//视屏号排行榜(发布排名)
export const getSphRankingInfo = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/ranking/getSphRankingInfo',
    params
  })
}
//快手排行榜(发布排名)
export const getKsRankingInfo = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/ranking/getKsRankingInfo',
    params
  })
}
